import { getLocalizedRoutes } from '@seek/melways-sites';

import {
  ROOT_PATH,
  URL_BRAND_REPORT,
  URL_CREATE_BRAND,
  URL_EDIT_BRAND,
  URL_LIST_BRANDS,
  URL_PREVIEW_BRAND,
} from './constants/urls';

const routes = [
  { name: 'root', route: ROOT_PATH },
  { name: 'listBrands', route: URL_LIST_BRANDS },
  { name: 'editBrand', route: URL_EDIT_BRAND },
  { name: 'addBrand', route: URL_CREATE_BRAND },
  { name: 'brandReport', route: URL_BRAND_REPORT },
  { name: 'previewBrand', route: URL_PREVIEW_BRAND },
];

export type RouteName = (typeof routes)[number]['name'];

export const localizedRoutesForSite = getLocalizedRoutes(routes);
